export default __webpack_public_path__ + "images/0xfa6de2697d59e88ed7fc4dfe5a33dac43565ea41.png";